import React, { createContext, useContext, useState, useCallback } from "react";

const ExcelDataContext = createContext();

export const ExcelDataProvider = ({ children }) => {
  const [excelDataTotal, setExcelDataTotal] = useState(null);

  const [excelData, setExcelData] = useState([]);

  const setExcelDataTotalSafe = useCallback((data) => {
    setExcelDataTotal(data);
    setExcelData((prev) => {
      const safePrev = Array.isArray(prev) ? prev : [];
      if (!data) return safePrev;
      const filtered = safePrev.filter((t) => t?.title !== data?.title);
      return [...filtered, data];
    });
  }, []);

  const addExcelTable = useCallback((tableOrUpdater) => {
    setExcelData((prev) => {
      const safePrev = Array.isArray(prev) ? prev : [];
      const table =
        typeof tableOrUpdater === "function"
          ? tableOrUpdater(safePrev)
          : tableOrUpdater;

      if (!table?.title) return safePrev;

      const exists = safePrev.some((t) => t.title === table.title);
      return exists
        ? safePrev.map((t) => (t.title === table.title ? table : t))
        : [...safePrev, table];
    });
  }, []);

  const clearExcelData = useCallback(() => {
    setExcelData([]);
    setExcelDataTotal(null);
  }, []);

  return (
    <ExcelDataContext.Provider
      value={{
        excelDataTotal,
        setExcelDataTotal: setExcelDataTotalSafe,
        excelData,
        setExcelData,
        addExcelTable,
        clearExcelData,
      }}
    >
      {children}
    </ExcelDataContext.Provider>
  );
};

export const useExcelData = () => useContext(ExcelDataContext);
